export default __webpack_public_path__ + "static/media/usdt_logo.cd0598f5.svg";